import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const SelectSeedingCuratorsRequestSchema = z
  .object({
    campaignId: z.union([z.string(), z.number()]),
    body: z.object({
      participationIds: z.array(z.number().int().min(1)).min(1).max(20),
    }),
  })
  .describe('SelectSeedingCuratorsRequestSchema');

export type SelectSeedingCuratorsRequest = z.infer<typeof SelectSeedingCuratorsRequestSchema>;

const SelectSeedingCuratorsSuccessDataSchema = z
  .object({})
  .passthrough()
  .describe('SelectSeedingCuratorsSuccessDataSchema');

const SelectSeedingCuratorsResponseSchema = createApiResponseSchema(
  SelectSeedingCuratorsSuccessDataSchema,
);

export type SelectSeedingCuratorsResponse = z.infer<typeof SelectSeedingCuratorsResponseSchema>;

export const selectSeedingCurators = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(SelectSeedingCuratorsRequestSchema),
    async (request: SelectSeedingCuratorsRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.post<SelectSeedingCuratorsResponse>(
          partnerApiPath.selectSeedingCurators(request.campaignId),
          request.body,
        ),
      ),
    validateApiResponse(SelectSeedingCuratorsResponseSchema),
  ),
);
